import React from 'react';
import { ArrowUturnLeftIcon, ArrowUturnRightIcon } from '@heroicons/react/24/outline';

interface UndoRedoBarProps {
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
}

const UndoRedoBar: React.FC<UndoRedoBarProps> = ({ canUndo, canRedo, onUndo, onRedo }) => {
  return (
    <div className="flex items-center gap-1">
      <button
        onClick={onUndo}
        disabled={!canUndo}
        className="p-1.5 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
        title="Annuler (Ctrl+Z)"
      >
        <ArrowUturnLeftIcon className="w-4 h-4 text-gray-600" />
      </button>
      <button
        onClick={onRedo}
        disabled={!canRedo}
        className="p-1.5 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
        title="Rétablir (Ctrl+Y)"
      >
        <ArrowUturnRightIcon className="w-4 h-4 text-gray-600" />
      </button>
    </div>
  );
};

export default UndoRedoBar;
